<pui-sub-header>
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div>
      <button pui-button variant="secondary" (click)="onGoBack()">
        <pui-icon left icon="arrow-left" />
        Powrót
      </button>
    </div>

    <div>
      @if(editMode){
      Edytuj podmiot uprawniony
      } @else {
      Dodaj podmiot uprawniony
      }
    </div>

    <div class="d-flex gap-12">
      <button pui-button variant="primary" (click)="onSubmit()">
        @if(editMode){
        Zapisz
        } @else {
        Dodaj podmiot
        }
      </button>
    </div>
  </div>
</pui-sub-header>

<form class="page-container" [formGroup]="entityForm">
  <pui-form-group [title]="'Ogólne'" [description]="'Podaj informacje ogólne, takie jak nazwa i typ podmiotu'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>Nazwa</pui-label>
        <input puiInput type="text" placeholder="Wprowadź nazwę podmiotu uprawnionego" formControlName="name" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityForm.get('name')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>

    <pui-form-row>
      <pui-form-field>
        <pui-label>Typ</pui-label>
        <pui-select [multiple]="false" formControlName="groupValue">
          <pui-placeholder>Wybierz</pui-placeholder>
          @for(option of groups(); track $index){
          <pui-option [value]="option">{{option}}</pui-option>
          }
        </pui-select>
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityForm.get('group')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>

  <pui-form-group [title]="'Dane kontaktowe'" [description]="'Podaj środki kontaktu wraz z organizacją zrzeszającą'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>E-mail</pui-label>
        <input puiInput type="text" placeholder="Wprowadź email" formControlName="email" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityForm.get('email')">
        </rqa-field-error>
      </pui-form-field>

    </pui-form-row>

    <div formArrayName="phones" class="pb-3xl">
      @for (phoneControl of phones.controls; track phoneControl; let i = $index) {

      <pui-form-row>
        <pui-form-field>
          <pui-label>Numer telefonu</pui-label>
          <input puiInput type="text" placeholder="Wprowadź telefon" rqaPhoneNumber [formControlName]="i" />
          <rqa-field-error ngProjectAs="pui-form-field-error" [control]="phoneControl">
          </rqa-field-error>

          @if(phones.controls.length > 1){
          <button type="button" pui-button [variant]="'primary'" [destructive]="true" (click)="removePhone(i)">
            Usuń
          </button>
          }
        </pui-form-field>
      </pui-form-row>

      }

      <pui-form-row>
        <button type="button" pui-button style="width: 100%;" [variant]="'secondary'" (click)="addPhone()"
          [disabled]="phones.controls.length >= 5">

          <pui-icon left icon="plus" />
          Dodaj kolejny numer
        </button>
      </pui-form-row>
    </div>

    <pui-form-row>
      <pui-form-field>
        <pui-label>Strona internetowa</pui-label>
        <input puiInput type="text" placeholder="www.adres.pl" formControlName="website" />
      </pui-form-field>
    </pui-form-row>

    <pui-form-row>
      <pui-form-field>
        <pui-label>Ulica</pui-label>
        <input puiInput type="text" placeholder="Nazwa ulicy" formControlName="street" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityForm.get('street')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>

    <pui-form-row>
      <pui-form-field>
        <pui-label>Miasto</pui-label>
        <input puiInput type="text" placeholder="Wpisz miasto" formControlName="city" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="entityForm.get('city')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>

  <pui-form-group [title]="'Informacje dodatkowe'" [description]="'Uzupełnij notatki i pomocnicze treści'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>Dodatkowe</pui-label>
        <textarea puiInput placeholder="Wpisz treść..." formControlName="note"></textarea>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>
</form>